var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvaxusdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "avax",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E84142;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 250,
    r: 250
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.2,256.5c8.7-15,22.6-15,31.3,0l53.9,94.7c8.7,15,1.6,27.2-15.7,27.2H299c-17.1,0-24.2-12.2-15.7-27.2 L338.2,256.5z M233.9,74.2c8.7-15,22.4-15,31.1,0l12,21.7l28.3,49.8c6.9,14.2,6.9,30.9,0,45.1l-95.1,164.8 c-8.7,13.4-23,21.9-39,22.8H92.3c-17.3,0-24.4-12-15.7-27.2L233.9,74.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaxusdt);
export default __webpack_public_path__ + "static/media/avaxusdt.24c4c543ce9f793be89c7019dd01fc18.svg";
export { ForwardRef as ReactComponent };